import React, { ReactNode } from "react";

interface IProps {
  title: string;
  description: ReactNode;
  imageUrl: string;
}

const GameCardDesktop: React.FC<IProps> = ({ title, description, imageUrl }) => {
  return (
    <div className="tw-w-full tw-mx-auto tw-rounded-[13px] tw-border-[2px] tw-overflow-hidden tw-bg-[#ffffff] tw-pb-[30px] tw-shadow-sm">
      <div className="tw-w-full tw-h-48 tw-relative">
        <img src={"https://hyperkarting-product-component.vercel.app/" + imageUrl} alt={title} className="tw-w-full tw-h-48 tw-object-cover" />
        <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-full tw-h-24 tw-bg-gradient-to-t tw-from-white" />
      </div>
      <div className="tw-mt-[20px] tw-px-[20px]">
        <div className="tw-text-[24px] tw-font-bold tw-text-black">{title}</div>
        <p
          className="tw-text-[#555758] tw-mt-[20px] tw-text-[14px] lg:tw-text-[16px]"
          dangerouslySetInnerHTML={{
            __html: description as string,
          }}
        />
      </div>
    </div>
  );
};

export default GameCardDesktop;
